module.exports = __webpack_public_path__ + "img/login-bg.9ca0da09.jpg";